if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;

      // The quantity input lives outside the <form> DOM but is associated via the
      // `form` attribute. FormData skips disabled inputs, so enable it here.
      const quantityInput = document.querySelector(`[name="quantity"][form="${this.form.id}"]`);
      if (quantityInput) quantityInput.disabled = false;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      // this.cartNotification = document.querySelector('cart-notification');

      this.initPurchaseOptions();
      this.updateDisplayedPrice();
    }

    initPurchaseOptions() {
      this.purchaseRadios = document.querySelectorAll('input[name="purchase"]');
      this.frequencySelect = document.querySelector('#subscription-plan');
      this.sellingPlanInput = document.querySelector('[name="selling_plan"]');

      this.purchaseRadios.forEach(radio => {
        radio.addEventListener('change', this.onPurchaseChange.bind(this));
      });

      if (this.frequencySelect) {
        this.frequencySelect.addEventListener('change', this.onFrequencyChange.bind(this));
      }

      this.syncSellingPlan();
    }

    onPurchaseChange() {
      this.syncSellingPlan();
      this.updateDisplayedPrice();
    }

    onFrequencyChange() {
      this.syncSellingPlan();
    }

    syncSellingPlan() {
      const selectedPurchase = document.querySelector('input[name="purchase"]:checked');

      if (!selectedPurchase) return;

      if (selectedPurchase.value === 'subscribe') {
        const selectedOption = this.frequencySelect?.selectedOptions[0];
        const planId = selectedOption?.value;

        if (planId) {
          this.sellingPlanInput.disabled = false;
          this.sellingPlanInput.value = planId;
        }
      } else {
        this.sellingPlanInput.value = '';
        this.sellingPlanInput.disabled = true;
      }
    }

    updateDisplayedPrice() {
      const selectedPurchase = document.querySelector('input[name="purchase"]:checked');

      if (!selectedPurchase) return;

      const price = selectedPurchase?.nextElementSibling?.querySelector('.variant-price:not(.hidden)')?.textContent;

      const priceEl = document.querySelectorAll('.main-product .price-item');
      if (priceEl && price) {
        priceEl.forEach(el => el.textContent = price);
      }
    }


    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      const idInput = this.form.querySelector('[name="id"]');
      const variantId = Number(idInput?.value);
      if (!variantId) return;

      // Read quantity explicitly — the input may sit outside the <form> DOM
      const quantityInput = document.querySelector(`[name="quantity"][form="${this.form.id}"]`)
        || document.querySelector('.quantity__input');
      const quantity = Number(quantityInput?.value) || 1;

      const sellingPlanInput = this.form.querySelector('[name="selling_plan"]');
      const sellingPlan = sellingPlanInput && !sellingPlanInput.disabled ? sellingPlanInput.value : null;

      submitButton.classList.add('loading');
      submitButton.setAttribute('aria-disabled', 'true');

      const finish = () => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      };

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.set('quantity', quantity);
      if (sellingPlan !== null) formData.set('selling_plan', sellingPlan);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          this.handleErrorMessage(false);
          if (window.Rebuy) {
            try { window.Rebuy.SmartCart.show(); } catch (_) {}
            try { window.Rebuy.Cart.refresh(); } catch (_) {}
            document.dispatchEvent(new CustomEvent('rebuy:cart:open'));
          }
          fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => {
              const count = Number(cart?.item_count || 0);
              document.querySelectorAll('.cart-item-count-js').forEach((badge) => {
                badge.textContent = count;
                if (count > 0) badge.removeAttribute('hidden-no-items');
                else badge.setAttribute('hidden-no-items', '');
              });
            });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(finish);
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.classList.toggle('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
